<template>
  <ul class="files-list">
    <li class="files-list__item"
      v-for="(item, idx) in dataSource"
      :key="idx"
    >
      <div
        class="files-list__close-icon"
        title="удалить изображение"
        @click.stop="$emit('deleteFile', idx)"
      >
        <trashСanIcon/>
      </div>
      <img
        :class="{
          'files-list__image': true,
          'files-list__image_active': idx === activeIdx
        }"
        alt="миниатюра"
        :src="envUrlBase + item.SourceFilePath"
        @click.stop="$emit('selectFile', item, idx)"
      >
      <div class="files-list__mark" v-if="item.FileId === frontImageId">
        <CheckMark/>
      </div>
    </li>
  </ul>
</template>

<script>
import { onMounted, ref } from 'vue'
import CheckMark from '@/components/icons/CheckMark.vue'
import trashСanIcon from '@/components/icons/trashСanIcon.vue'

export default {
  name: 'ImageUploaderFileList',
  components: {
    CheckMark,
    trashСanIcon
  },
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    activeIdx: {
      type: Number,
      default: 0
    },
    frontImageId: {
      type: Number,
      default: 0
    }
  },
  setup () {
    const envUrlBase = ref(null)

    // const envUrlBase = process.env.VUE_APP_URL_BASE + '/'

    onMounted(() => {
      if (localStorage.activeProject === 'site') {
        envUrlBase.value = process.env.VUE_APP_URL_BASE + '/'
      } else if (localStorage.activeProject === 'education') {
        envUrlBase.value = process.env.VUE_APP_URL_EDUCATION + '/'
      }
    })

    return {
      envUrlBase
    }
  }
}
</script>

<style lang="scss" scoped>
.files-list {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 661px;
  height: 125px;
  overflow-x: auto;

  &__item {
    position: relative;
  }

  &__close-icon {
    position: absolute;
    width: 24px;
    height: 24px;
    bottom: 11px;
    right: 8px;
    cursor: pointer;
    display: block;
    padding: 2px;
    border-radius: 4px;
    background-color: #C51B0E;
    transition: 0.5s;

    &:hover {
      background-color: #A11208;
    }
    &:active {
      background-color: #7B0D05;
    }
  }

  &__image {
    width: 153px;
    height: 86px;
    border-radius: 6px;
    object-fit: cover;
    background-color: #FFFFFF;
    border: 3px solid transparent;

    &_active {
      border: 3px solid #00ABEC;
    }
  }

  &__mark {
    position: absolute;
    right: 10px;
    bottom: 20px;
  }

  /* Стили для скролла */
  &::-webkit-scrollbar {
    height: 5px; /* ширина для горизонтального скролла */
    background-color: rgba(192, 192, 192, 0.5);
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(27, 166, 218, 0.7);

    &:hover {
      background-color: rgb(27, 166, 218);
    }
  }

}

</style>
